export const About = (): JSX.Element => {
  return (
    <div id="about" className="section">
      <div>
        Frontend software engineer with experience working at Amazon (AWS),
        Fareportal and Parsons Corporation, totaling 10+ years of professional
        experience.
      </div>
      <div>
        Driven creator inspired by technology with a passion for designing,
        building, and scaling products to their full potential. Committed to
        precision and accuracy, not just in engineering, but in life as well.
      </div>
    </div>
  );
};
